class FooterAccordion extends HTMLElement {
  constructor() {
    super();

    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.summaryIsEmpty = this.summaryToggle.textContent.trim().length == 0;

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );

    document.addEventListener('matchSmall', this.matchSmall.bind(this));
    document.addEventListener('unmatchSmall', this.unmatchSmall.bind(this));

    if (!theme.config.mqlSmall || this.summaryIsEmpty) {
      this.detailsContainer.setAttribute('open', true);

      if (this.summaryIsEmpty) {
        this.detailsContainer.setAttribute('empty', true);
      }
    } else {
      if (this.dataset.open == undefined)
        this.detailsContainer.removeAttribute('open');
    }

    window.matchMedia(theme.config.mediaQuerySmall).matches? this.matchSmall(): this.unmatchSmall();
  }

  matchSmall() {
    console.log('small')
    this.close();
    this.detailsContainer.removeAttribute('role');
    this.summaryToggle.removeAttribute('role');
    this.summaryToggle.removeAttribute('aria-level');
    this.summaryToggle.setAttribute('tabindex', '0');
  }

  unmatchSmall() {
    this.open();
    this.detailsContainer.setAttribute('role', 'presentation');
    this.summaryToggle.setAttribute('role', 'heading');
    this.summaryToggle.setAttribute('aria-level', '3');
    this.summaryToggle.setAttribute('tabindex', '-1');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open();
  }

  open() {
    this.detailsContainer.setAttribute('open', true);
  }

  close() {
    theme.config.mqlSmall &&
      !this.summaryIsEmpty &&
      this.detailsContainer.removeAttribute('open');
  }
}

customElements.define('footer-accordion', FooterAccordion);
